const vehicleGroup = {
    namespaced: true,
    state: {
        vehicleGroupList:[],
        selectedVehicleGroup: null,
    },
    mutations: {
        updateVehicleGroupList(state, newList) {
            state.vehicleGroupList = newList;
        },
        updateSelectedVehicleGroup(state, newGroup) {
            state.selectedVehicleGroup = newGroup;
        }
    },
    actions: {
        getVehicleGroupList(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/vehiclegroup/getVehicleGroups')
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateVehicleGroupList', response.data);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        saveVehicleGroup(context, newVehicleGroup) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/vehiclegroup/saveVehicleGroup', newVehicleGroup)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getVehicleGroupList');
                            resolve(response);
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },
        deleteVehicleGroup(context, vehicleGroupId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/vehiclegroup/deleteVehicleGroup', { params: { "id": vehicleGroupId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getVehicleGroupList');
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        }
    }
}

export default vehicleGroup;